import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './list.styl'

export default class List extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    inline: PropTypes.bool
  }

  render() {
    const { children, inline } = this.props
    const content = [].concat(children)
    const listClasses = [styles.list]

    inline && listClasses.push(styles.inline)

    return (
      <ul className={listClasses.join(' ')}>
        {content.map((item, index) => (
          <li key={index} className={styles.item}>
            {item}
          </li>
        ))}
      </ul>
    )
  }
}
